import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#14AAA6',
        secondary: '#10938F',
        accent: '#ae1431',
        success: '#4CAF50',
        warning: '#FF9800',
        error: '#F44336',
        info: '#2196F3',
        background: '#f5f7fa',
        surface: '#ffffff',
      },
    },
  },
});
